// extracted by mini-css-extract-plugin
export var divider = "_xn-0";